import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Encode icon path for use in <img src> (handles special chars like á) */
export function encodeIconPath(path: string): string {
  return encodeURI(path);
}
